const advPHlist = document.getElementsByClassName('js-advPH')

if (advPHlist[0]) {
  placeholderCheck()

  window.addEventListener('input', function (e) {
    // 指定のクラスを持つ
    if (e.target.classList.contains('js-advPH')) {
      placeholderCheck()
    }
  })
}
function placeholderCheck() {
  for (const iterator of advPHlist) {
    const target = document.querySelector('.js-advPH--' + iterator.dataset.ph)
    if (iterator.value === '') {
      target.classList.add('active')
    } else {
      target.classList.remove('active')
    }
  }
}
